module.exports = __webpack_public_path__ + "img/icon_iphone.e6c98c09.png";